import React, { Component } from 'react';
import { Grid, Button, Icon, Confirm } from 'semantic-ui-react';
import ShortButton from "./ShortButton";
//import ReactHTMLTableToExcel from 'react-html-table-to-excel';
    export class QryOutputHeader extends Component {    
        constructor(props) {
            super(props);
            this.state = {
                "proceedToPscBtnTxt": "PROCEED TO PSC",
                "showReconcileAlert": false,
                "isReconciling": false,
                initTime: Date.now(),
            }
            this.proceedToPsc = this.proceedToPsc.bind(this);
        }
        
        proceedToPsc(){
            this.props.startPsc();
            this.setState({"proceedToPscBtnTxt": "PLEASE WAIT..."})
            setTimeout(()=>{
                this.props.closeModal();
            },5000)
        }

        getReconciliationButton(){
            let {qryType, bolIdData} = this.props
            const stateFilter = qryType === "ES" ? "SHIPMENT_US_ES_PROCESS" : "SHIPMENT_US_CR_PROCESS"
            const acceptedFilters = qryType === "ES" 
                ? ["STATE_ENTRY_SUMMARY_ACCEPTED", "STATE_ENTRY_SUMMARY_ACCEPTED_WITH_WARNINGS"] 
                : ["STATE_CARGO_RELEASE_ACCEPTED", "STATE_CARGO_RELEASE_ACCEPTED_WITH_WARNINGS"] 
            const bolState = bolIdData && bolIdData.states && bolIdData.states.states.find(state => state.key === stateFilter)
            const isAccepted = bolState && bolState.value && acceptedFilters.includes(bolState.value.state)
            if(!bolIdData)return <React.Fragment></React.Fragment>;
            if(!isAccepted && (qryType === "ES" || qryType === "CR")){
                const resolutionStatus = qryType === "ES" ? bolIdData.esReconciliationStatus : bolIdData.crReconciliationStatus
                if(resolutionStatus === "RECONCILIATION_NOT_ATTEMPTED" || resolutionStatus === "RECONCILIATION_NOT_POSSIBLE"){
                    return <ShortButton id='reconAgainBtn' className="ace-toggle-btn" onClick={() => {
                        if(!this.props.startedReconcile){
                            this.props.startReconcileClicked();
                        }
                    }}>{
                        this.props.startedReconcile 
                        ? `STARTED ${qryType} STATUS SYNC`
                        : resolutionStatus === "RECONCILIATION_NOT_POSSIBLE"
                            ? `RETRY ${qryType} STATUS SYNC`
                            : `START ${qryType} STATUS SYNC`
                        }
                    </ShortButton>
                }
                else if(resolutionStatus === "RECONCILIATION_POSSIBLE"){
                    return <ShortButton id='reconAgainBtn' className="ace-toggle-btn" onClick={() => {
                        if(!this.state.showReconcileAlert){
                            this.setState({"showReconcileAlert": true})
                        }
                    }}>{this.state.isReconciling ? `${qryType} STATUS SYNCING...` : `CONFIRM ${qryType} STATUS SYNC`}</ShortButton>
                }
                else if(resolutionStatus === "RECONCILIATION_IN_PROGRESS"){
                    return <ShortButton id='reconAgainBtn' className="ace-toggle-btn">{`${qryType} STATUS SYNC IN PROGRESS`}</ShortButton>
                }
            }
        }

        componentDidMount() {
            if(this.props.qryType == "BOL"){
                this.props.runAgainClicked && this.props.runAgainClicked();
            }
        }
        render() {
            const isDisabledBtn = this.props.enableProceedToPsc ? '' : 'disabledForm'
            let {qryType, adminAccountReadonly} = this.props;
            if(qryType=="CRITERIAQUERYQQ")qryType="CQ";
            if(qryType=="RESPONSE_SUMMARY")qryType="RSS";
            let disabledPeriod = 15500;
            let disabledRunAgain = (this.state.initTime +disabledPeriod) > Date.now();
            
            if(this.props.qryType !== "BOL"){
                disabledRunAgain = false;
            }
            return (
                <Grid>
                    <span style={{display:'none'}}>
                        {disabledRunAgain && setTimeout(()=>{this.setState({})},1000)}
                    </span>
                <Grid.Row columns={3} className='qryLabelHeading'>
                    {/* <Grid.Column width={1}>
                    
                    <div className={`oval`}>

                        {
                            qryType === 'ADCVD' ? <div className={`${qryType.toLowerCase()}Oval qryOval`}>AD<br />CVD</div> : 
                            <div className={`${qryType.toLowerCase()}Oval qryOval`}>
                                {qryType=="RSS"?"CBP":qryType}
                            </div>
                        }
                        
                    </div>
                    </Grid.Column>   */}
                    <Grid.Column width={9} className={`qryLabel`}>
                        &nbsp;
                    {qryType === "IB" ? `Importer & Bond Query result`: 
                    qryType === "RSS" ? `CBP Status Summary`:
                    `${this.props.queryRanFor ? this.props.queryRanFor : qryType} Query result`}
                    </Grid.Column>
                
                    <Grid.Column width={6} style={{"textAlign": "right"}}>
                        {/* <ReactHTMLTableToExcel  
                            className="btn btn-info"  
                            table="resultTbl"  
                            filename="ReportExcel"  
                            sheet="Sheet"  
                            buttonText="Export excel" />   
                            <div id='exportResult' className='btn exportResultBtn'>EXPORT RESULT</div>*/}
                        {adminAccountReadonly && <div style={{padding:'10px'}}>ADMIN</div>}
                        {(qryType === "ES" || qryType === "CR") && !adminAccountReadonly && this.getReconciliationButton()}
                        {qryType !== "RSS"&& (!adminAccountReadonly || qryType=="BOL")  &&
                            ['ISF_HEADER','BOL_FORM', 'EN_FORM', 'BOLHeader', 'MERCHANDISE_LINE'].includes(this.props.launchFrom) && <ShortButton id='runAgainBtn' 
                            className={"ace-toggle-btn "+(disabledRunAgain?" disabled ":" ")}
                            disabled={disabledRunAgain}
                            onClick={
                                ()=>{
                                if(!this.props.runningAgain && !disabledRunAgain){
                                    this.props.runAgainClicked()
                                    this.setState({initTime: Date.now()})
                                }  
                                // setTimeout(()=>{
                                //    this.props.runAgainClicked()
                                // },300)
                            }}>{this.props.runningAgain ? `RUNNING...` : `RUN AGAIN`} 
                            {disabledRunAgain && <React.Fragment>&nbsp;({Math.round((this.state.initTime +disabledPeriod - Date.now())/1000)})</React.Fragment>}
                            </ShortButton> 
                        }
                        { qryType === "ES" && this.props.launchFrom === 'ESHeader' && <div id='proceedToPsc' className={`btn proceedToPsc runAgainBtn ${isDisabledBtn}`} onClick={this.proceedToPsc}>{this.state.proceedToPscBtnTxt}</div> }
                        {/* { props.qryType !== 'ADCVD' && <div id='selectQueryBtn' className='btn selectQueryBtn'>SELECT QUERY</div> } */}
                        <Confirm
                            open={this.state.showReconcileAlert}
                            content={`Sync ${qryType} status with latest query result?`}
                            onCancel={() =>  this.setState({"showReconcileAlert": false})}
                            onConfirm={() => {
                                this.props.processReconcile(); 
                                this.setState({"showReconcileAlert": false})
                                this.setState({"isReconciling": true})
                                setTimeout(()=>{
                                    this.setState({"isReconciling": false})
                                }, 2500)
                            }}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid> 
            )
        }
}